/* @flow */

export const RESET_NEW_TRIP_REQUEST = '@trip-requests/RESET_NEW_TRIP_REQUEST';
export const RESET_CREATED_NEW_TRIP_REQUEST = '@trip-requests/RESET_CREATED_NEW_TRIP_REQUEST';
export const SET_NEW_TRIP_REQUEST_CONTACTS = '@trip-requests/SET_NEW_TRIP_REQUEST_CONTACTS';
export const SET_NEW_TRIP_REQUEST_DAY = '@trip-requests/SET_NEW_TRIP_REQUEST_DAY';
export const SET_NEW_TRIP_REQUEST_USE_CASE = '@trip-requests/SET_NEW_TRIP_REQUEST_USE_CASE';
export const SET_NEW_TRIP_REQUEST_PARTNER_SESSION = '@trip-requests/SET_NEW_TRIP_REQUEST_PARTNER';
export const SET_NEW_TRIP_REQUEST_DESCRIPTION = '@trip-requests/SET_NEW_TRIP_REQUEST_DESCRIPTION';
export const SET_NEW_TRIP_REQUEST_DESTINATION_ID =
  '@trip-requests/SET_NEW_TRIP_REQUEST_DESTINATION_ID';
export const SET_NEW_TRIP_REQUEST_ORIGIN_ID = '@trip-requests/SET_NEW_TRIP_REQUEST_ORIGIN_ID';
export const SET_NEW_TRIP_REQUEST_PAYMENT_SOURCE_ID =
  '@trip-requests/SET_NEW_TRIP_REQUEST_PAYMENT_SOURCE_ID';
export const SET_NEW_TRIP_REQUEST_PRODUCT = '@trip-requests/SET_NEW_TRIP_REQUEST_PRODUCT';
export const SET_NEW_TRIP_REQUEST_PROMO_CODE = '@trip-requests/SET_NEW_TRIP_REQUEST_PROMO_CODE';
export const SET_NEW_TRIP_REQUEST_QUERY_STRING = '@trip-requests/SET_NEW_TRIP_REQUEST_QUERY_STRING';
export const SET_NEW_TRIP_REQUEST_TIME = '@trip-requests/SET_NEW_TRIP_REQUEST_TIME';
export const SET_NEW_TRIP_REQUEST_ON_DEMAND = '@trip-requests/SET_NEW_TRIP_REQUEST_ON_DEMAND';
export const SET_NEW_TRIP_REQUEST_FARE_ESTIMATE_ID =
  '@trip-requests/SET_NEW_TRIP_REQUEST_FARE_ESTIMATE_ID';
export const ADD_NEW_TRIP_REQUEST_PHOTO = '@trip-requests/ADD_NEW_TRIP_REQUEST_PHOTO';
export const REMOVE_NEW_TRIP_REQUEST_PHOTO = '@trip-requests/REMOVE_NEW_TRIP_REQUEST_PHOTO';



// WEBPACK FOOTER //
// ./src/redux/trip-requests/actionTypes.js